import { render, staticRenderFns } from "./pptcontent.vue?vue&type=template&id=3b61c60e&scoped=true"
import script from "./pptcontent.vue?vue&type=script&lang=js"
export * from "./pptcontent.vue?vue&type=script&lang=js"
import style0 from "./pptcontent.vue?vue&type=style&index=0&id=3b61c60e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b61c60e",
  null
  
)

export default component.exports